import { AICallWidget, UserCallWidget } from './components'
import { CallInitiator } from '@numeo/types'
import './styles/index.css'
import { Dispatch, SetStateAction } from 'react'

interface CallWidgetProps {
    callId: string
    initiatedBy: CallInitiator
    index: number
    listeningCallId: string | null
    setListeningCallId: Dispatch<SetStateAction<string | null>>
}

export const CallWidget = ({ callId, initiatedBy, index, listeningCallId, setListeningCallId }: CallWidgetProps) => {
    switch (initiatedBy) {
        case CallInitiator.AI:
            return <AICallWidget callId={callId} index={index} listeningCallId={listeningCallId} setListeningCallId={setListeningCallId} />
        case CallInitiator.USER:
            return <UserCallWidget callId={callId} index={index} />
        default:
            return null
    }
}
